<template>
  <div class="wrap">
    <div v-for="(item, index) in urlList" :key="index" :class="item[itemKey] ? 'no_border':''" class="img-upload">
      <img class="img" :src="item[itemKey]" alt="img" />
      <div class="hover">
        <i class="el-icon-zoom-in icon" @click="handleImgClick(index)"></i>
        <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove(index)"></i>
      </div>
    </div>
    <div v-if="urlList.length<+limit && !disabled" class="img-upload">
      <input
        ref="input"
        :accept="accept"
        class="input"
        type="file"
        :multiple="multiple"
        @change="handleChange" />
      <i v-if="!uploading" class="el-icon-plus plus-icon"></i>
      <svg v-if="uploading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="60px" height="60px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#e15b64" stroke="none">
          <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
        </path>
      </svg>
    </div>
  </div>
</template>

<script>
// import { imageUploadApi } from './fetch'
import { uploadFile } from 'src/utils/upload'
import ImageFullScreen from '@/widget/Viewer'
const fileType = {
  png: 'image',
  jpeg: 'image',
  jpg: 'image',
}
export default {
  name: 'SingleUpload',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    itemKey: {
      type: String,
      default: 'url',
    },
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024,
    },
    limit: {
      type: [String, Number],
      default: 9,
    },
    accept: {
      type: String,
      default: '.png,.jpg,.jpeg,.JPG,.PNG,.JPEG',
    },
    multiple: Boolean,
  },
  data () {
    return {
      urlList: [],
      percent: 0,
      uploading: false,
    }
  },
  watch: {
    urlList (newVal, oldVal) {
      this.$emit('input', newVal?.length ? newVal : null)
      this.$emit('change', newVal?.length ? newVal : null)
      this.dispatch('ElFormItem', 'el.form.change', newVal?.length ? [newVal] : [])
    },
    value: {
      handler: function (newVal, oldVal) {
        const a = JSON.stringify(newVal)
        const b = JSON.stringify(oldVal)
        if (a !== b) {
          if (newVal && newVal.length) {
            this.urlList = newVal
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    getFileSuffix (name) {
      return name.slice(name.lastIndexOf('.') + 1).toLowerCase()
    },
    // 图片上传
    async handleChange ({ target }) {
      try {
        if (!target.files.length) return
        if (target.files.length + this.urlList.length > +this.limit) {
          this.$warn(`最多可上传${this.limit}张图片！`)
          return
        }
        const files = Array.from(target.files)
        let sizeFlag = false
        let suffixFlag = false
        files.forEach(item => {
          const suffix = this.getFileSuffix(item.name)
          if (!fileType[suffix]) {
            suffixFlag = true
          }
          if (item.size > this.maxSize) {
            const tips = this.maxSize < 1024 * 1024 ? `${this.maxSize / 1024}K` : `${this.maxSize / 1024 / 1024}M`
            this.$warn(`图片大小不能大于${tips}！`)
            sizeFlag = true
          }
        })
        if (suffixFlag) {
          throw new Error('只允许上传png、jpeg、jpg文件！')
        }
        if (sizeFlag) return
        this.uploading = true
        // 图片处理
        const uploadList = files.map(file => {
          // const formData = new FormData()
          // formData.append('file', file)
          return uploadFile(file)
        })
        // 图片上传
        const res = await Promise.all(uploadList)
        res.forEach(item => {
          this.urlList.push({
            url: item,
          })
        })
        this.$refs.input.value = ''
      } catch (e) {
        this.$error(e)
      } finally {
        this.uploading = false
      }
    },
    // 图片删除
    handleRemove (index) {
      this.urlList.splice(index, 1)
    },
    // // 图片查看
    handleImgClick (index) {
      ImageFullScreen({
        list: this.urlList,
        itemKey: 'url',
        index: index,
      })
    },
    dispatch (componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },

  },
}
</script>

<style lang="scss" scoped>

.wrap{
  display: flex;
  flex-wrap: wrap;
}
.img-upload {
  width: 82px;
  height: 82px;
  position: relative;
  display: flex;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px dashed #DCDFE6;
  &.no_border{
    border: none;
  }
}
.img-upload .img {
  width: 100%;
  height: 100%;
  // cursor: zoom-in;
  border-radius: 4px;

}
.img-upload .process {
  padding: 20px;
}
.img-upload .input {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.img-upload .plus-icon {
  font-size: 24px;
  color: #c0c4cc;
}
.delete-icon {
  font-size: 20px;
  color: rgb(38,50,56);
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
}
.img-upload:hover{
  .hover{
    display: flex;
  }
}
.hover{
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #409eff;
  font-size: 18px;
  background-color: rgba(0,0,0,.6);
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  .icon{
    cursor: pointer;
  }
  .del-icon{
    margin-left: 5px;
  }
}
</style>
